import QueryKeys from "../api/queryKeys";
import { ISODateString } from "../types/date";

export const QueryKeyBuilder = {
  Attendance: (groupId: number) => [QueryKeys.Attendance, groupId],
  MidweekSubs: (groupId: number, from: ISODateString, to: ISODateString) => [QueryKeys.MidweekSubs, groupId, from, to],
  MidweekInfo: (groupId: number, from: ISODateString, to: ISODateString) => [QueryKeys.MidweekInfo, groupId, from, to],
  CustomAssignments: (from: ISODateString, to: ISODateString) => [QueryKeys.CustomAssignments, from, to],
};
